<template>
  <div class="introduction-container">
    <div class="cover2-container">
      <img class="cover2-book" :class="{ active: showCover2Ani }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cover/4/cover-book.png" />
      <img class="cover2-text" :class="{ active: showCover2Ani }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cover/3/cover-text-6.png" />
    </div>

    <transition name="fade">
      <div class="cover1-container" v-if="!hidddenCover1">
        <img class="cover1-logo" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cover/3/logo2.png" />
      </div>
    </transition>
    <!-- 优先显示视频 -->
    <transition name="fade">
      <div class="video-container" v-if="!hiddenVideo">
        <video class="home-video" poster="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video-poster.jpg" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video8.mp4" width="100%" height="100%" id="home-video"></video>
        <!-- <video class="home-video" poster="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video-poster.jpg" controls src="https://res.cqnews.net/ires/2023/6/16/dSvys0Kwb7yDihF0xkX3DCXc6q8sCXWpD9i.mp4" width="100%" height="100%" id="home-video" autoplay></video> -->

        <img class="endplay" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/endplay.png" @click="skipVideo" />
      </div>
    </transition>
    <img v-if="hiddenVideo" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/all-logo2.png" class="all-logo" />
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      showCover2Ani: false,
      // 隐藏第二页
      hidddenCover1: false,
      // 隐藏视频
      hiddenVideo: false
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    init() {
      const video = document.getElementById('home-video')
      video.play()
      video.addEventListener('ended', () => {
        this.skipVideo()
      })
    },
    skipVideo() {
      this.hiddenVideo = true
      this.$emit('startBgm')
      // 3妙
      setTimeout(() => {
        this.hidddenCover1 = true
        setTimeout(() => {
          this.showCover2Ani = true
          setTimeout(() => {
            // 出现右侧按钮
            this.$emit('showSwiperRight')
          }, 3000)
        }, 1000)
      }, 3000)
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.init()
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
$originWidth: 1920;
$originHeight: 919;

.all-logo {
  position: absolute;
  width: percentage(288 / $originWidth);
  height: percentage(41 / $originHeight);
  left: percentage(67 / $originWidth);
  top: percentage(62 / $originHeight);
}
.introduction-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  .cover2-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cover/2/cover2_2.jpg') no-repeat;
    background-size: 100% 100%;
    .cover2-book {
      position: absolute;
      opacity: 0;
      width: percentage(1493 / $originWidth);
      height: percentage(805 / $originHeight);
      left: percentage(223 / $originWidth);
      top: percentage(115 / $originHeight);
    }
    .cover2-book.active {
      animation: book-ani 1s ease-out forwards;
    }
    @keyframes book-ani {
      0% {
        opacity: 0;
        transform: translateY(100%);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
    .cover2-text {
      position: absolute;
      opacity: 0;
      width: percentage(950 / $originWidth);
      height: percentage(638 / $originHeight);
      left: percentage(411 / $originWidth);
      top: percentage(282 / $originHeight);
    }
    .cover2-text.active {
      animation: text-ani 2s ease-out forwards;
      animation-delay: 1.5s;
    }
    @keyframes text-ani {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
  }
  .cover1-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cover/3/cover1_2.jpg') no-repeat;
    background-size: 100% 100%;
    .cover1-logo {
      position: absolute;
      width: percentage(1094 / $originWidth);
      height: percentage(558 / $originHeight);
      left: percentage(391 / $originWidth);
      top: percentage(70 / $originHeight);
      animation: scale-up 6s infinite;
    }
    @keyframes scale-up {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.05);
      }
      100% {
        transform: scale(1);
      }
    }
  }
  .video-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    .home-video {
      object-fit: fill;
    }
    .endplay {
      position: absolute;
      cursor: pointer;
      right: 3%;
      top: 3%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Introduction/index.vue